
        import { c as camera, j as controls } from "./assets/scene-CqtYl5hY.js";

        (function () {
            let lastMobileState = null;

            function applyResponsiveFraming(force = false) {
                if (!camera || !controls) return;
                const isMobile = window.innerWidth <= 768;

                if (!force && lastMobileState === isMobile) return;
                lastMobileState = isMobile;

                if (isMobile) {
                    // Mobile view: elevate target and move camera back so pergola
                    // sits cleanly in the visible viewport above the compact bottom drawer.
                    controls.maxDistance = 350;
                    controls.minDistance = 30;
                    controls.target.set(0, 9.5, 0);
                    camera.position.set(92, 65, 122);
                    camera.updateProjectionMatrix();
                    controls.update();
                } else {
                    // Desktop view: standard framing
                    controls.maxDistance = 200;
                    controls.minDistance = 50;
                    controls.target.set(0, 8, 0);
                    camera.position.set(60, 40, 80);
                    camera.updateProjectionMatrix();
                    controls.update();
                }
            }

            let checkCount = 0;
            const initInterval = setInterval(() => {
                checkCount++;
                if (camera && controls && window.__pergolaScene) {
                    applyResponsiveFraming(true);
                    clearInterval(initInterval);
                } else if (checkCount > 60) {
                    clearInterval(initInterval);
                }
            }, 100);

            let resizeTimer;
            window.addEventListener("resize", () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => applyResponsiveFraming(false), 150);
            });

            document.querySelectorAll('input[name="pergolaType"]').forEach(r => {
                r.addEventListener('change', () => {
                    setTimeout(() => applyResponsiveFraming(true), 400);
                });
            });
        })();
    